
const info = {};

info.isIE = typeof(navigator)=="object" && navigator.userAgent.match("Trident") != null;

info.hasTouch = null;

info.hasMouse = info.isIE ||
    typeof(window) == "object" &&
    window.matchMedia &&
    (window.matchMedia("(any-hover: none)").matches ||
        window.matchMedia("(pointer:fine)").matches );

export default info;